export default "__VITE_ASSET__B7KIuG65__"